<div #ref class="header">
   <div *ngIf="title" class="default">
      <h1 class="display-4">{{ title }}</h1>
   </div>
   <ng-content></ng-content>   
</div>